import * as CAMPAIGN_CONST from './../Campaigns/const'

const initState = {}

export function conversions(state = initState, action) {
  switch (action.type) {
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      var result = {
        ...state,
        ...(() => {
          var conversions = {}
          var cityPlans = action.result.data.campaign.cityPlans.nodes
          cityPlans.forEach(cityPlan => {
            cityPlan.missions.edges.forEach(({ node }) => {
              node.conversions.nodes.forEach(conversion => {
                conversions[conversion.id] = {
                  ...conversion,
                  metricId: conversion.metric.id,
                }
              })
            })
          })
          return conversions
        })(),
      }
      return result

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Conversions/reducer.js